import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({selector: '[querySwitchGroup]'})
export class QuerySwitchGroupDirective {
  constructor(public template: TemplateRef<any>) {}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/components/query-builder/query-switch-group.directive.ts